import React from 'react';

interface ThinArrowIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
    stroke?: string;
    className?: string;
}

const ThinArrowIcon: React.FC<ThinArrowIconProps> = ({
    width = 19,
    height = 11,
    fill = 'none',
    stroke = 'white',
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 19 11"
            fill={fill}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.668 10L9.5013 1.83333L1.33463 10"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ThinArrowIcon;
